module.exports = __webpack_public_path__ + "coin_ZCORE.png?dd58d652805658b02a688eb307b42fad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_ZCORE.png
// module id = 1116
// module chunks = 2